import React from "react";
import { StepViewComponent } from "../../model/steps/steps-model";
import { VerticalListStepView } from "./vertical-list-step-view";

export const RadioVerticalListStepView: StepViewComponent = props => (
  <div>
    <VerticalListStepView {...props} radioMode={true} />
  </div>
);
